import { TableActionsWrapper } from '@components'

import { ReactElement } from 'react'

import { useInvoicesList } from '../../context/invoicesList'
import { InvoicesPeriodSelector } from './elements/InvoicesPeriodSelector'
import { InvoicesSearch } from './elements/InvoicesSearch'
import { InvoicesTitle } from './elements/InvoicesTitle'
import * as Styled from './styles'

export const InvoicesTableActions = (): ReactElement | null => {
  const { options, setColumnsFilteringContainer } = useInvoicesList()
  const { showColumnsFilteringInActions, showPeriodSelector, showSearch, showTitle } = options

  const hasEndActions = showPeriodSelector || showColumnsFilteringInActions
  const hasActions = showTitle || showSearch || hasEndActions

  if (!hasActions) {
    return null
  }

  return (
    <TableActionsWrapper>
      {showTitle && <InvoicesTitle />}
      {showSearch && <InvoicesSearch />}
      {hasEndActions && (
        <Styled.InvoicesTableEndActionsWrapper>
          {showPeriodSelector && <InvoicesPeriodSelector />}
          {showColumnsFilteringInActions && (
            <Styled.InvoicesTableColumnsFilteringContainer ref={setColumnsFilteringContainer} />
          )}
        </Styled.InvoicesTableEndActionsWrapper>
      )}
    </TableActionsWrapper>
  )
}
